export default __webpack_public_path__ + "static/media/sticker-us.5ffa9e47.png";